// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__1QZZj","checkmark":"checkbox_checkmark__OgGTl"};